import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-message-filled",
  "use": "foquz-icon-message-filled-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" id=\"foquz-icon-message-filled\"><path d=\"M10.5 0h-9C.673 0 0 .673 0 1.5v6C0 8.327.673 9 1.5 9H4v2.5c0 .23.262.363.448.227L8 9h2.5c.827 0 1.5-.673 1.5-1.5v-6c0-.827-.673-1.5-1.5-1.5z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol